import { ISeoPage } from "../../types/types";
import EssentialData from "../../../../private/classes/EssentialData.class";
import { BaseSeoAdapter } from "./BaseSeoAdapter";
import { EnumScreenNames } from "../../../../enums/EnumScreenNames";
import { ICountryAssetLite } from "models/Assets/ICountryAsset";
import { Localization } from "../Localization.class";

export class StaticContentsAdapter extends BaseSeoAdapter {
  private localization: Localization
  constructor(
    essentialData: EssentialData,
    private lang: string = "ar",
    private country: ICountryAssetLite,
  ) {
    super(essentialData);
  }

  getData(screenKey: EnumScreenNames): ISeoPage {
    return this.localization.getJson(screenKey);
  }

  setLocalization(localization: Localization): void {
    this.localization =  localization;
  }

  getSerpData(screenKey: EnumScreenNames): ISeoPage {
    return this.localization.getJson(screenKey);
  }
}
